import { useEffect, useState } from "react"
import { Button, Modal } from "components"
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import toast from "react-hot-toast"
import { useApi } from "utils"
import { SelectOptionType } from "types"
import { FormWarehouse, ListWarehouse } from "../types"
import { FormSection } from "./FormSection"

const schema = yup.object({
  warehouse_code: yup.string().label("Code").required().max(3, "Max 3 characters"),
  warehouse_name: yup.string().label("Warehouse").required().max(200),
  location_id: yup.number().label("Location").required(),
})

function getNextCode(existingCodes: string[]): string {
  const numeric = existingCodes
    .map(c => parseInt(c, 10))
    .filter(n => !isNaN(n))
  const max = numeric.length > 0 ? Math.max(...numeric) : 0
  return String(max + 1).padStart(3, "0")
}

export function CreateModal({ toggle, refetch, locationOptions, locationLoading }: { toggle: () => void; refetch: () => void; locationOptions: SelectOptionType[]; locationLoading: boolean }) {
  const api = useApi()
  const [codeLoading, setCodeLoading] = useState(true)
  const methods = useForm<FormWarehouse>({
    defaultValues: { warehouse_code: "", warehouse_name: "", location_id: undefined },
    resolver: yupResolver(schema) as any
  })

  useEffect(() => {
    api.get("/location-warehouse/")
      .then((res) => {
        const items: ListWarehouse[] = res.data?.payload ?? []
        const codes = items.map(i => i.warehouse_code)
        methods.setValue("warehouse_code", getNextCode(codes))
      })
      .catch(() => methods.setValue("warehouse_code", "001"))
      .finally(() => setCodeLoading(false))
  }, []) // eslint-disable-line

  const onSubmit = (value: FormWarehouse) => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.post("/location-warehouse/add", value),
        { loading: "Loading...", success: (res) => res.data.message, error: (err) => err.response.data.message }
      ).then(() => { toggle(); refetch() }).catch(() => {}).finally(resolve)
    })
  }

  return (
    <Modal isOpen title="CREATE WAREHOUSE" closeModal={toggle}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Modal.Body>
            <FormSection locationOptions={locationOptions} locationLoading={locationLoading} isCodeLoading={codeLoading} />
          </Modal.Body>
          <Modal.Footer className="text-end">
            <Button type="submit" color="primary" disabled={codeLoading} loading={methods.formState.isSubmitting ? "true" : undefined}>Save</Button>
          </Modal.Footer>
        </form>
      </FormProvider>
    </Modal>
  )
}
